<template>
  <div class="form-container position-absolute top-50 start-50 translate-middle">
    <div class="bb-outer-area">
      <div class="auth-box text-center">
        <img class="mt-4 mb-3" src="/bbLogo32Blue.png" alt="logo" />
        <!-- ------------ -->
        <!--    form      -->
        <!-- ------------ -->
        <form @submit.prevent="passwordChange">
          <!-- ---------------- -->
          <!--   old password   -->
          <!-- ---------------- -->
          <div class="form-group">
            <div class="form-floating mt-3 mb-3">
              <input v-model="old_password" v-bind:class="{
                'is-invalid': errorFields.includes('old_password'),
              }" id="old_password" placeholder="old password" :type="fieldTypes.password" class="form-control"
                autocomplete="off" required />
              <label class="bb-float-label" for="old_password">Old Password</label>
              <!-- -------------------------- -->
              <!--   show/hide old password   -->
              <!-- -------------------------- -->
              <div class="input-group-addon">
                <i class="bi bi-eye-slash" id="toggleOldPassword"></i>
              </div>
            </div>
          </div>
          <!-- ------------------ -->
          <!--   new password 1   -->
          <!-- ------------------ -->
          <div class="form-group">
            <div class="form-floating password mb-3">
              <input v-model="new_password1" v-bind:class="{
                'is-invalid': errorFields.includes('new_password1'),
              }" name="new_password1" class="form-control" placeholder="new password" :type="fieldTypes.password"
                id="new_password1" autocomplete="off" required />
              <label class="bb-float-label" for="new_password1">New Password</label>
              <!-- ---------------------------- -->
              <!--   show/hide new password 1   -->
              <!-- ---------------------------- -->
              <div class="input-group-addon">
                <i class="bi bi-eye-slash" id="toggleNewPassword1"></i>
              </div>
            </div>
          </div>
          <!-- ------------------ -->
          <!--   new password 2   -->
          <!-- ------------------ -->
          <div class="form-group">
            <div class="form-floating password mb-3">
              <input v-model="new_password2" v-bind:class="{
                'is-invalid': errorFields.includes('new_password2'),
              }" name="new_password2" class="form-control" placeholder="repeat password" :type="fieldTypes.password"
                autocomplete="off" id="new_password2" required />
              <label class="bb-float-label" for="new_password2"> Repeat Password</label>
              <!-- ---------------------------- -->
              <!--   show/hide new password 2   -->
              <!-- ---------------------------- -->
              <div class="input-group-addon">
                <i class="bi bi-eye-slash" id="toggleNewPassword2"></i>
              </div>
            </div>
          </div>
          <!-- ------------ -->
          <!--    errors    -->
          <!-- ------------ -->
          <div v-for="err in errors" :key="err.id" class="bb-error-wrap mt-2">
            {{ err }}
          </div>
          <!-- ------------ -->
          <!--  button row  -->
          <!-- ------------ -->
          <div class="row mt-4 mb-3">
            <!-- ------------ -->
            <!--    buttons   -->
            <!-- ------------ -->
            <div class="btn-group special mt-3 mb-2" role="group">
              <!-- ------------ -->
              <!--    cancel    -->
              <!-- ------------ -->
              <button @click="$router.go(-1)" class="btn btn-lg btn-warning">Cancel</button>
              <!-- ------------ -->
              <!--      OK      -->
              <!-- ------------ -->
              <button type="submit" :disabled="!old_password || !new_password1 || !new_password2"
                class="btn btn-lg btn-primary">
                OK
              </button>
            </div>
          </div>
          <!-- ------------ -->
          <!--    submit    -->
          <!-- ------------ -->
          <!-- <div class="d-grid">
            <button
              type="submit"
              :disabled="!old_password || !new_password1 || !new_password2"
              class="btn btn-lg btn-primary mt-3"
            >
              Change Password
            </button>
          </div> -->
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'
//----------------------
// scripts
//----------------------
export default {
  name: 'changePasswordView',
  data() {
    return {
      old_password: '',
      new_password1: '',
      new_password2: '',
      errors: [],
      errorFields: [],
      fieldTypes: {
        password: 'password',
      },
    }
  },
  //----------------------
  // methods
  //----------------------
  methods: {
    ...mapActions('auth', {
      changePassword: 'changePassword',
    }),
    ...mapMutations('auth', {
      setMessage: 'setMessage',
      setCurrentView: 'setCurrentView',
    }),
    setView(view) {
      this.setCurrentView(view)
    },
    //-------------------------
    // change password method
    //-------------------------
    async passwordChange() {
      this.errors = []
      this.errorFields = []
      const payload = {
        new_password1: this.new_password1,
        new_password2: this.new_password2,
        old_password: this.old_password,
      }
      //----------------------
      // api call
      //----------------------
      await this.changePassword({ payload })
        //-----------------------------------
        // where successful (force re-logon)
        //-----------------------------------
        .then(() => {
          this.setMessage('Password changed successfully.\nPlease logon with your new credentials.')
          this.$router.push({ name: 'logoutView' })
        })
        //----------------------
        // where error
        //----------------------
        .catch((err) => {
          this.errors.push(window.bbErrorMsg(err))
          this.errorFields.push(window.bbErrorKey(err))
        })
    },
  },
  //-------------------------
  // on mount
  //-------------------------
  mounted() {
    this.setView('partial')
    //-------------------------
    // set bg color
    //-------------------------
    document.body.className = 'bb-bg-partial'
    //---------------------------------
    // toggle password display (setup)
    //---------------------------------
    const toggleOldPassword = document.querySelector('#toggleOldPassword')
    const old_password = document.querySelector('#old_password')
    toggleOldPassword.addEventListener(
      'click',
      togglePassword.bind(null, toggleOldPassword, old_password),
      false
    )

    const toggleNewPassword1 = document.querySelector('#toggleNewPassword1')
    const new_password1 = document.querySelector('#new_password1')
    toggleNewPassword1.addEventListener(
      'click',
      togglePassword.bind(null, toggleNewPassword1, new_password1),
      false
    )

    const toggleNewPassword2 = document.querySelector('#toggleNewPassword2')
    const new_password2 = document.querySelector('#new_password2')
    toggleNewPassword2.addEventListener(
      'click',
      togglePassword.bind(null, toggleNewPassword2, new_password2),
      false
    )
    //------------------------------------
    // toggle password display (function)
    //------------------------------------
    function togglePassword(eye, el) {
      const type = el.getAttribute('type') === 'password' ? 'text' : 'password'
      el.setAttribute('type', type)
      eye.classList.toggle('bi-eye')
    }
  },
  unmounted() {
    document.body.className = 'bb-bg-full'
    this.setView('campaigns')
  },
}
</script>